module.exports = __webpack_public_path__ + "img/pen-suit (5).551142af.png";